// İSG Portal — "şu kişinin çekmecesini aç" gezinme durumu (GL5). URL yok: yalnız router STATE.
// Durum güvenilmezdir (her şey `navigate(..., { state })` verebilir), uuid doğrulanır; istek
// callback'ten ÖNCE temizlenir ki yenileme tekrar oynatmasın; diğer state anahtarları (EP `openTab`) korunur.

import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface OpenPersonnelState {
  openPersonnel: string;
}
export const openPersonnelState = (userUuid: string): OpenPersonnelState => ({
  openPersonnel: userUuid,
});

function requestedUuid(state: unknown): string | null {
  if (typeof state !== 'object' || state === null) return null;
  const value = (state as { openPersonnel?: unknown }).openPersonnel;
  return typeof value === 'string' && UUID.test(value) ? value : null;
}

/**
 * List screens call this once. When `ready` (the list has loaded, so the opener element exists) and the
 * location state asks for a person, the request is removed from history with `replace` and `onOpen`
 * runs exactly once. A uuid that is not in the list is still consumed; the host simply finds no row.
 */
export function useConsumeOpenPersonnel({
  ready,
  onOpen,
}: {
  ready: boolean;
  onOpen: (userUuid: string) => void;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const onOpenRef = useRef(onOpen);
  const consumedKey = useRef<string | null>(null);
  useEffect(() => {
    onOpenRef.current = onOpen;
  });
  const requested = requestedUuid(location.state);
  useEffect(() => {
    if (requested === null || !ready || consumedKey.current === location.key) return;
    consumedKey.current = location.key; // StrictMode re-runs this effect with the same closure
    const { openPersonnel: _consumed, ...rest } = location.state as Record<string, unknown>;
    navigate(
      { pathname: location.pathname, search: location.search, hash: location.hash },
      { replace: true, state: Object.keys(rest).length > 0 ? rest : null },
    );
    onOpenRef.current(requested);
  }, [
    requested,
    ready,
    location.key,
    location.pathname,
    location.search,
    location.hash,
    location.state,
    navigate,
  ]);
}
